var a={label:"label__2SeSny","spin-animation":"spin-animation__DemrgG","ball-beat-animation":"ball-beat-animation__palZZB","hide-scroll-animation":"hide-scroll-animation__FG1-BP"};export{a as default};
